import { FC } from "react";
import { useHeadAdaBalance } from "@/hooks/useHeadAdaBalance";

interface TvlBannerProps {
  className?: string;
  compact?: boolean;
}

export const TvlBanner: FC<TvlBannerProps> = ({ className, compact = false }) => {
  const { formatted } = useHeadAdaBalance();

  if (!formatted) return null;

  return (
    <div
      className={`flex items-center justify-center gap-2 py-1.5 text-xs text-sr-neutral-500 ${compact ? "gap-1 py-0 text-[11px]" : ""} ${className ?? ""}`}
    >
      <span>TVL:</span>
      <span className="text-sr-lemon-muted font-medium tabular-nums">
        {formatted} ADA
      </span>
    </div>
  );
};
